/**
 * 정산 관리 협력사 API 클라이언트
 */
import { apiClient } from "@/shared/api/client";
import { PartnerListItem, PartnerNameItem, PartnerSearchFilters } from "../types/partnerAccounting.types";

const BASE_PATH = '/api/v1/withdrawal-limit/partner';

export const partnerAccountingApi = {
    getPartnerList: async (): Promise<PartnerListItem[]> => {
        const response = await apiClient.get<PartnerListItem[]>(`${BASE_PATH}/list`);
        return response.data;
    },

    searchPartners: async (filters: PartnerSearchFilters): Promise<PartnerListItem[]> => {
        const response = await apiClient.get<PartnerListItem[]>(`${BASE_PATH}/search`, { params: filters });
        return response.data;
    },

    getPartnerNames: async (): Promise<PartnerNameItem[]> => {
        const response = await apiClient.get<PartnerNameItem[]>(`${BASE_PATH}/names`);
        return response.data;
    },

    updateWithdrawalStatus: async (suppId: string, withdrawalYn: 'Y' | 'N'): Promise<void> => {
        await apiClient.post<void>(`${BASE_PATH}/withdrawal`, { suppId, withdrawalYn });
    },
};
